export default __webpack_public_path__ + "assets/fonts/7a654dd9970c44eccc3c20df04c0b247.png";